import { DIRECT_CALL_RULES } from 'constants/feature/adobe-analytics-constants';
import DirectCallRule from 'models/data/adobe-direct-call-rule-model';
import {
  isDataLayerReady,
  isSatelliteReady,
  appendDCRQueue,
  getDCRQueue,
  setDCRQueue,
  trackDCR,
  getRoutePageName,
} from 'utils/adobe-analytics-utils';
import { isNullOrUndefined } from 'utils/object-utils';

// Adobe Analytics action types
export const SET_ADOBE_NEW_PROJECT_DATA_ACTION_TYPE =
  'adobe-track-new-project-view-action';

export const createSetAdobeNewProjectDataAction = () => ({
  type: SET_ADOBE_NEW_PROJECT_DATA_ACTION_TYPE,
});

export const SET_ADOBE_NEW_PROJECT_DATA_ACTION = {
  type: SET_ADOBE_NEW_PROJECT_DATA_ACTION_TYPE,
};

// Custom action type for location changes in React Router v6
export const LOCATION_CHANGE_ACTION_TYPE = 'LOCATION_CHANGE_ACTION';

export function locationChangeAction(pathname) {
  return {
    type: LOCATION_CHANGE_ACTION_TYPE,
    payload: { pathname },
  };
}

const adobeAnalyticsMiddleware = (store) => (next) => (action) => {
  if (isNullOrUndefined(action)) {
    return next(action);
  }
  // Handle custom location change action
  if (action.type === LOCATION_CHANGE_ACTION_TYPE) {
    const { pathname } = action.payload;
    const event = new DirectCallRule(DIRECT_CALL_RULES.NEW_PAGE_VIEW, {
      pageInfo: { pageName: getRoutePageName(pathname) },
    });
    appendDCRQueue(event);
  } else if (action.type === SET_ADOBE_NEW_PROJECT_DATA_ACTION_TYPE) {
    const event = new DirectCallRule(DIRECT_CALL_RULES.NEW_PROJECT_VIEW);
    appendDCRQueue(event);
  }

  const queue = getDCRQueue();
  if (isDataLayerReady() && isSatelliteReady() && queue.length > 0) {
    queue.forEach((event) => trackDCR(event, false));
    setDCRQueue([]);
  }

  return next(action);
};

export default adobeAnalyticsMiddleware;
